import {rootState} from '@mintdata-wsp/common/state/RootState';
import {VisualComponent} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/VisualComponent';
import {VisualComponentsSection} from '@mintdata-wsp/common/state/ui/visualDesigner/SurfaceEditorState';
import {WSPIcon} from '@mintdata-wsp/resources/icons/WSPIcon';
import {WSPIcons, WSPIconSize} from '@mintdata-wsp/resources/icons/WSPIcons';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {
    VisualComponentPreview,
    VisualComponentPreviewMode
} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/panels/outline/components/VisualComponentPreview';
import * as classnames from 'classnames/bind';
import {action} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SurfaceComponentsSectionView.less');
const cx = classnames.bind(styles);

export interface VisualComponentsSectionProps
{
    section:VisualComponentsSection;
}

@observer
export class SurfaceComponentsSectionView extends React.Component<VisualComponentsSectionProps, any>
{
    @action.bound
    private _toggleSectionExpansion()
    {
        const {section} = this.props;
        section.isExpanded = !section.isExpanded;
    }

    private _renderHeader()
    {
        const {section} = this.props;

        return <Row className={cx('sectionHeader')} onClick={this._toggleSectionExpansion}>
            {
                section.isExpanded ?
                    <WSPIcon className={cx('collapseExpandIcon')}
                             name={WSPIcons.common.ArrowDown}
                             size={WSPIconSize.medium16} />
                    :
                    <WSPIcon className={cx('collapseExpandIcon')}
                             name={WSPIcons.common.ArrowRight}
                             size={WSPIconSize.medium16} />
            }
            <Row>
                <b> {section.sectionName}</b>
            </Row>
        </Row>;
    }

    render()
    {
        const {section} = this.props;
        const isExpanded:boolean = section.isExpanded;
        const filterString:string = controllers.ui.workbench.getFilterString();
        const mode = VisualComponentPreviewMode.ListItem;
        const {dragContext} = rootState.ui.visualDesigner.surfaceEditor.glass;

        return (
            <Column key={section.id} className={cx('sectionColumn', 'visible')}>
                {this._renderHeader()}
                <Column className={cx('componentsRow', {'visible': isExpanded}, {'notVisible': !isExpanded})}>
                    {
                        section.components.map((vc:VisualComponent, i:number) =>
                        {
                            return vc && (
                                <VisualComponentPreview
                                    key={`${vc.id}`}
                                    mode={mode}
                                    component={vc}
                                    isComponentDragging={dragContext ? vc.id === dragContext.componentToDrag.id : false}
                                    highlightNamePart={filterString}
                                />
                            );
                        })
                    }
                </Column>
            </Column>
        );
    }
}
